/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckRulesMismatch } from './PaxCheckRulesMismatch';
import {
    PaxCheckRulesMismatchFromJSON,
    PaxCheckRulesMismatchFromJSONTyped,
    PaxCheckRulesMismatchToJSON,
    PaxCheckRulesMismatchToJSONTyped,
} from './PaxCheckRulesMismatch';

/**
 * 
 * @export
 * @interface PaxCheckRulesMismatches
 */
export interface PaxCheckRulesMismatches {
    /**
     * 
     * @type {Array<PaxCheckRulesMismatch>}
     * @memberof PaxCheckRulesMismatches
     */
    mismatches: Array<PaxCheckRulesMismatch>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckRulesMismatches
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckRulesMismatches interface.
 */
export function instanceOfPaxCheckRulesMismatches(value: object): value is PaxCheckRulesMismatches {
    if (!('mismatches' in value) || value['mismatches'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckRulesMismatchesFromJSON(json: any): PaxCheckRulesMismatches {
    return PaxCheckRulesMismatchesFromJSONTyped(json, false);
}

export function PaxCheckRulesMismatchesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRulesMismatches {
    if (json == null) {
        return json;
    }
    return {
        
        'mismatches': ((json['mismatches'] as Array<any>).map(PaxCheckRulesMismatchFromJSON)),
        'type': json['type'],
    };
}

export function PaxCheckRulesMismatchesToJSON(json: any): PaxCheckRulesMismatches {
    return PaxCheckRulesMismatchesToJSONTyped(json, false);
}

export function PaxCheckRulesMismatchesToJSONTyped(value?: PaxCheckRulesMismatches | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mismatches': ((value['mismatches'] as Array<any>).map(PaxCheckRulesMismatchToJSON)),
        'type': value['type'],
    };
}

